import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { getDisplayValue } from "../Utility/Utility";
import { showSmallLoadingImage,showLoadingImage } from "../Utility/Utility"; // Ensure this is the correct path for your loading image

const AddRefundDialog = ({
  open,
  onClose,
  onSave,
  newRefund,
  setNewRefund,
  refundPaymentModes = [],
  isSaving = false, // Add isSaving prop to manage saving state
}) => {
  const [error, setError] = useState({
    refundMode: false,
    amount: false,
  });

  const validateForm = () => {
    const errors = {};
    if (!newRefund.refundMode) errors.refundMode = true;
    if (!newRefund.amount || isNaN(newRefund.amount)) errors.amount = true;
    setError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = () => {
    if (validateForm()) {
      onSave(); // This should trigger the save operation and set isSaving to true
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle sx={{ fontWeight: 600, fontSize: "20px" }}>
        Add New Refund
      </DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth margin="normal" error={error.refundMode}>
          <InputLabel>Refund Mode</InputLabel>
          <Select
            label="Refund Mode"
            value={newRefund.refundMode}
            onChange={(e) =>
              setNewRefund({ ...newRefund, refundMode: e.target.value })
            }
          >
            {refundPaymentModes.map((mode) => (
              <MenuItem key={mode} value={mode}>
                {getDisplayValue(mode)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Refunded To"
          fullWidth
          margin="normal"
          value={newRefund.refundedTo}
          onChange={(e) =>
            setNewRefund({ ...newRefund, refundedTo: e.target.value })
          }
        />
        <TextField
          label="Amount"
          fullWidth
          margin="normal"
          type="number"
          value={newRefund.amount}
          onChange={(e) =>
            setNewRefund({
              ...newRefund,
              amount: parseFloat(e.target.value),
            })
          }
          error={error.amount}
          helperText={error.amount && "Please enter a valid amount."}
        />
        <TextField
          label="Notes"
          fullWidth
          multiline
          rows={3}
          value={newRefund.notes || ""}
          onChange={(e) =>
            setNewRefund({ ...newRefund, notes: e.target.value })
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Close
        </Button>
        {isSaving && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(216, 214, 214, 0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1301, // Above dialog
      }}
    >
      {showLoadingImage()}
    </div>
  )}

  {/* Save button always shows "Save" */}
  <Button
    onClick={handleSave}
    variant="contained"
    color="secondary"
    disabled={isSaving}
  >
    Save
  </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddRefundDialog;